export default "__VITE_ASSET__B9346XsB__"